import angular from 'angular';
import flatpickr from 'flatpickr';
import moment from 'moment';

angular.module('angular-flatpickr', []).directive('ngFlatpickr', ngFlatpickr);

function ngFlatpickr() {
    return {
        restrict: 'A',
        scope: {
            fpOptions: '&'
        },
        link: function(scope, element) {
            var options = scope.fpOptions();

            options.onOpen = function() {
                var value = input.val();
                if (!value) {
                    fp.clear();
                    return;
                }

                var newDate = moment(value, options.dateFormat);
                if (!newDate.isValid()) {
                    fp.clear();
                    return;
                }

                fp.setDate(newDate.toDate());
            };
            // focus back input field when calendar is closed
            options.onClose = function() {
                input.focus();
            };

            // set flatpickr's date parser
            options.formatDate = function(date, dateFormat) {
                return moment(date).format(dateFormat);
            };
            options.parseDate = function(dateStr) {
                return moment(dateStr, options.dateFormat).toDate();
            };

            var fp = new flatpickr(element[0], options),
                input = angular.element(fp.input);

            scope.$on('flatpickr:open', function() {
                fp.open();
            });

            scope.$on('flatpickr:toggle', function() {
                fp.toggle();
            });

            scope.$on('flatpickr:close', function() {
                fp.close();
            });

            scope.$on('$destroy', function() {
                fp.destroy();
            });
        }
    };
}
